import React, { useCallback, useMemo } from 'react';
import { Secretariat, SystemStatus } from '../../store/models';
import { Instance } from 'mobx-state-tree';
import BaseGrid from '../common/grid/BaseGrid';
import { Translate } from '../../typings/typings';
import { TLCode } from '../../common/enums';
import { Page } from '../../common/enums/Page';
import EditCell from '../common/grid/EditCell';
import { ICellRendererParams } from 'ag-grid-community';

interface SystemStatusListProps {
  systemStatuses: Array<Instance<typeof SystemStatus>>;
  secretariats: Array<Instance<typeof Secretariat>>;
  translate: Translate;
  navigate: (url: string) => void;
}

export const SystemStatusList = ({ systemStatuses, secretariats, translate, navigate }: SystemStatusListProps) => {
  const gridColumns = useMemo(() => {
    return [
      {
        headerName: translate(TLCode.SYSTEM_STATUS_SystemStatusId),
        sort: 'asc',
        width: 100,
        field: 'systemStatusId',
      },
      {
        headerName: translate(TLCode.SYSTEM_STATUS_SystemStatusName),
        width: 300,
        field: 'systemStatusName',
      },
      {
        headerName: translate(TLCode.SYSTEM_STATUS_SystemStatusValue),
        width: 300,
        field: 'status',
      },
      {
        headerName: translate(TLCode.SYSTEM_STATUS_SystemStatusYear),

        width: 200,
        field: 'year',
      },
      {
        headerName: translate(TLCode.SYSTEM_STATUS_SystemStatusSecretariat),

        width: 200,
        field: 'secretariat',
      },
      {
        width: 100,
        headerName: '',
        sortable: false,
        filter: false,
        cellRendererFramework: EditCell,
        cellRendererParams: (params: ICellRendererParams) => {
          return {
            onEditButtonClick: () => {
              navigateToSystemStatusForm(params.data.systemStatusId);
            },
          };
        },
      },
    ];
  }, [translate]);

  const gridData = useMemo(() => {
    return systemStatuses.map((e) => {
      const secretariat = secretariats.find((s) => s.secretariatId === e.secretariatId);
      const secretariatCode =
        secretariats.find((s) => s.secretariatId === e.secretariatId) !== undefined ? secretariat!.code : '';
      return {
        systemStatusId: e.systemStatusId,
        systemStatusName: e.subSystem,
        status: e.status,
        year: e.year,
        secretariat: secretariatCode,
      };
    });
  }, [systemStatuses, secretariats]);

  const navigateToSystemStatusForm = useCallback(
    (systemStatusId: number) => {
      navigate(`${Page.SystemStatusPage}/${systemStatusId}`);
    },
    [navigate],
  );

  const goToSystemStatusForm = useCallback(
    (ev) => {
      navigateToSystemStatusForm(ev.data.systemStatusId);
    },
    [navigateToSystemStatusForm],
  );

  return (
    <BaseGrid
      columnDefs={gridColumns}
      rowData={gridData}
      keyName="systemStatusId"
      onRowDoubleClicked={goToSystemStatusForm}
    />
  );
};
